import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import InputLabel from '../../../rxlib/components/input-label';
import Redirecionar from '../../../rxlib/components/redirecionar';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import ItemLicencaBaseCadastro from '../../item-licenca-base/cadastro';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';

import {
    ApiError,
    LicencaBase,
    CadastroProps,
    ItemLicencaBaseTemp,
} from '../../../services/tipos';

function LicencaBaseCadastro(props: CadastroProps) {
    const [salvo, setSalvo] = useState<boolean>(false);
    const [showDetail, setShowDetail] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [carregandoDetalhe, setCarregandoDetalhe] = useState<boolean>(false);
    const [actionDetalhe, setActionDetalhe] = useState(props.match.params.action);
    const [idItemLicencaBaseTemp, setIdItemLicencaBaseTemp] = useState<string>('');

    const [licencaBase, setLicencaBase] = useState<LicencaBase>({
        id: '',
        chave: '',
        descricao: '',
    });

    const [itensLicencaBase, setItensLicencaBase] = useState<[ItemLicencaBaseTemp]>([{
        id: '',
        tempId: 0,
        valorItem: '',
        idLicencaBase: '',
        idItemLicenca: '',
        personalizado: false,
        itemLicenca: {
            id: '',
            nome: '',
            chave: '',
            tipoControle: '',
        },
    }]);

    const { register, handleSubmit } = useForm<LicencaBase>();

    const handleHideWarning = () => setShowWarning(false);

    const handleHideDetail = () => setShowDetail(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Licenças base', link: '/licencabase' },
        { texto: props.match.params.action ? 'Visualização' : props.match.params.id ? 'Edição' : 'Novo', link: '' },
    ];

    const configuracoesTabelaDetalhe: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'nome', entidadePai: 'itemLicenca', tipo: 'string' },
            { nome: 'Chave', campo: 'chave', entidadePai: 'itemLicenca', tipo: 'string' },
            { nome: 'Tipo de controle', campo: 'tipoControle', entidadePai: 'itemLicenca', tipo: 'tipoControle' },
            { nome: 'Personalizado', campo: 'personalizado', tipo: 'boolean' },
        ],
    }

    const temPermissao = props.match.params.action
        ? usuarioTemPermissao(token, 'licenca_base_visualizar')
        : props.match.params.id
            ? usuarioTemPermissao(token, 'licenca_base_editar')
            : usuarioTemPermissao(token, 'licenca_base_novo');

    const podeVisualizarDetalhe = usuarioTemPermissao(token, 'itens_licenca_base_visualizar');
    const podeVisualizarNoDetalhe = podeVisualizarDetalhe ? handleVisualizarDetalhe : undefined;
    const podeNovoDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'itens_licenca_base_novo') ? handleNovoDetalhe : undefined : undefined;
    const podeEditarDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'itens_licenca_base_editar') ? handleEditarDetalhe : undefined : undefined;

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.id) {
                api.get(`/LicencaBase/${props.match.params.id}`)
                    .then(response => {
                        setLicencaBase({
                            id: response.data.id,
                            chave: response.data.chave,
                            descricao: response.data.descricao,
                        });
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error, 'Não foi possível carregar a licença base: ');
                    });
            } else {
                setLicencaBase({
                    id: '',
                    chave: '',
                    descricao: '',
                });
            }
        }
    }, [props.match.params.id, temPermissao]);

    useEffect(() => {
        if ((temPermissao) && (podeVisualizarDetalhe)) {
            if (props.match.params.id) {
                setCarregandoDetalhe(true);
                api.get(`/OData/ItemLicencaBase?$expand=itemLicenca&$filter=idLicencaBase eq ${props.match.params.id}`)
                    .then(response => {
                        setTimeout(() => {
                            let itens: [ItemLicencaBaseTemp] = [{
                                id: '',
                                tempId: 0,
                                valorItem: '',
                                idLicencaBase: '',
                                idItemLicenca: '',
                                personalizado: false,
                                itemLicenca: {
                                    id: '',
                                    nome: '',
                                    chave: '',
                                    tipoControle: '',
                                },
                            }];

                            for (let contador = 0; contador < response.data.value.length; contador++) {
                                if (contador === 0) {
                                    itens[0] = {
                                        tempId: contador + 1,
                                        id: response.data.value[contador].Id,
                                        valorItem: response.data.value[contador].ValorItem,
                                        idLicencaBase: response.data.value[contador].IdLicencaBase,
                                        idItemLicenca: response.data.value[contador].IdItemLicenca,
                                        personalizado: response.data.value[contador].Personalizado,
                                        itemLicenca: {
                                            id: response.data.value[contador].ItemLicenca.Id,
                                            nome: response.data.value[contador].ItemLicenca.Nome,
                                            chave: response.data.value[contador].ItemLicenca.Chave,
                                            tipoControle: response.data.value[contador].ItemLicenca.TipoControle,
                                        },
                                    };
                                } else {
                                    itens.push({
                                        tempId: contador + 1,
                                        id: response.data.value[contador].Id,
                                        valorItem: response.data.value[contador].ValorItem,
                                        idLicencaBase: response.data.value[contador].IdLicencaBase,
                                        idItemLicenca: response.data.value[contador].IdItemLicenca,
                                        personalizado: response.data.value[contador].Personalizado,
                                        itemLicenca: {
                                            id: response.data.value[contador].ItemLicenca.Id,
                                            nome: response.data.value[contador].ItemLicenca.Nome,
                                            chave: response.data.value[contador].ItemLicenca.Chave,
                                            tipoControle: response.data.value[contador].ItemLicenca.TipoControle,
                                        },
                                    });
                                }
                            }

                            setItensLicencaBase(itens);
                            setCarregandoDetalhe(false);
                        }, 250);
                    }).catch(error => {
                        setCarregandoDetalhe(false);
                        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                        setShowWarning(true);
                    });
            }
        }
    }, [props.match.params.id, temPermissao, podeVisualizarDetalhe]);

    const onSubmit: SubmitHandler<LicencaBase> = data => {
        if ((itensLicencaBase.length <= 0) || (itensLicencaBase[0].tempId <= 0) || (!!!itensLicencaBase[0].tempId)) {
            setMessageWarning(['Não é possível salvar a licença base sem informar ao menos um item.']);
            setShowWarning(true);
        } else {
            processarSubmit(data);
        }
    }

    function processarSubmit(data: LicencaBase) {
        setCarregando(true);
        props.match.params.id
            ? editar(data)
            : salvar(data);
    }

    function salvar(data: LicencaBase) {
        api.post('/LicencaBase', data)
            .then(response => {
                let itens: [ItemLicencaBaseTemp] = atualizarItensComIdLicenca(response.data.id);
                setItensLicencaBase(itens);
                processarDetalhe();
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar a licença base: ');
            });
    }

    function atualizarItensComIdLicenca(idLicencaBase: string): [ItemLicencaBaseTemp] {
        let itens: [ItemLicencaBaseTemp] = [{
            id: '',
            tempId: 0,
            valorItem: '',
            idItemLicenca: '',
            idLicencaBase: '',
            personalizado: false,
            itemLicenca: {
                id: '',
                nome: '',
                chave: '',
                tipoControle: '',
            },
        }];

        for (let contador = 0; contador < itensLicencaBase.length; contador++) {
            if (contador === 0) {
                itens[0] = itensLicencaBase[contador];
                itens[0].idLicencaBase = idLicencaBase;
            } else {
                itensLicencaBase[contador].idLicencaBase = idLicencaBase;
                itens.push(itensLicencaBase[contador]);
            }
        }

        return itens;
    }

    function editar(data: LicencaBase) {
        api.put('/LicencaBase', data)
            .then(response => {
                processarDetalhe();
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar a licença base: ');
            });
    }

    function processarDetalhe() {
        function salvarDetalhe(itemLicencaBase: ItemLicencaBaseTemp) {
            if ((itemLicencaBase.idLicencaBase !== '') && (itemLicencaBase.idItemLicenca !== '')) {
                if (!!itemLicencaBase.id) {
                    editarDetalhe(itemLicencaBase);
                } else {
                    novoDetalhe(itemLicencaBase);
                }
            }
        }

        function novoDetalhe(data: ItemLicencaBaseTemp) {
            api.post('/ItemLicencaBase', {
                valorItem: data.valorItem,
                idLicencaBase: data.idLicencaBase,
                personalizado: Boolean(data.personalizado),
                idItemLicenca: data.idItemLicenca,
            }).then(response => {
                if (contador < (itensLicencaBase.length - 1)) {
                    contador++;
                    salvarDetalhe(itensLicencaBase[contador]);
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar o item da licença base: ');
                setCarregando(false);
            });
        }

        function editarDetalhe(data: ItemLicencaBaseTemp) {
            api.put('/ItemLicencaBase', {
                id: data.id,
                valorItem: data.valorItem,
                idLicencaBase: data.idLicencaBase,
                personalizado: Boolean(data.personalizado),
                idItemLicenca: data.idItemLicenca,
            }).then(response => {
                if (contador < (itensLicencaBase.length - 1)) {
                    contador++;
                    salvarDetalhe(itensLicencaBase[contador]);
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar o item da licença base: ');
                setCarregando(false);
            });
        }

        let contador: number;
        if (itensLicencaBase.length > 0) {
            contador = 0;
            salvarDetalhe(itensLicencaBase[contador]);
        }

        handleSalvar(false);
    }

    function handleSalvar(acaoDetalheRealizada: boolean) {
        if (!acaoDetalheRealizada) {
            setSalvo(true);
        }
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    function handleNovoDetalhe() {
        setActionDetalhe(props.match.params.action);
        setIdItemLicencaBaseTemp('');
        setTimeout(() => {
            setShowDetail(true);
        }, 50);
    }

    function handleEditarDetalhe(tempId: string) {
        setActionDetalhe(props.match.params.action);
        setIdItemLicencaBaseTemp(tempId);
        setTimeout(() => {
            setShowDetail(true);
        }, 50);
    }

    function handleVisualizarDetalhe(tempId: string) {
        setIdItemLicencaBaseTemp(tempId);
        setActionDetalhe('view');
        setTimeout(() => {
            setShowDetail(true);
        }, 50);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{props.match.params.action ? 'Visualizar' : props.match.params.id ? 'Editar' : 'Nova'} licença base</h6>
                            </div>
                        </div>
                        {
                            props.match.params.id
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            name='id'
                                            type='text'
                                            id='inputId'
                                            maxLength={50}
                                            readOnly={true}
                                            label='Código:'
                                            autoFocus={false}
                                            defaultValue={licencaBase.id}
                                            placeholder='Código da licença base'
                                            referencia={register({ required: true })} />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    autoFocus={true}
                                    name='descricao'
                                    label='Descrição:'
                                    id='inputDescricao'
                                    placeholder='Descrição'
                                    defaultValue={licencaBase.descricao}
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    name='chave'
                                    label='Chave:'
                                    maxLength={50}
                                    id='inputChave'
                                    autoFocus={false}
                                    placeholder='Chave'
                                    defaultValue={licencaBase.chave}
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        {
                            podeVisualizarDetalhe
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <Listagem
                                            campoId='tempId'
                                            listagemDetalhe={true}
                                            tipoBotaoAcao='button'
                                            onNovo={podeNovoDetalhe}
                                            onEditar={podeEditarDetalhe}
                                            fonteDados={itensLicencaBase}
                                            carregando={carregandoDetalhe}
                                            descricao='Itens da licença base'
                                            onVisualizar={podeVisualizarNoDetalhe}
                                            configuracoesTabela={configuracoesTabelaDetalhe}
                                            idEntidadePai={licencaBase.id ? licencaBase.id : '0'} />
                                    </div>
                                </div>
                                : ''
                        }
                        <ButtonsCrud
                            carregando={carregando}
                            styleButton='btn-rxlib'
                            linkCancelarVoltar='/licencabase'
                            visualizar={props.match.params.action === 'view'} />
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <ItemLicencaBaseCadastro
                    show={showDetail}
                    tratarErro={tratarErro}
                    onSalvar={handleSalvar}
                    onHide={handleHideDetail}
                    fonteDados={itensLicencaBase}
                    idLicencaBase={licencaBase.id}
                    readOnly={actionDetalhe === 'view'}
                    setFonteDados={setItensLicencaBase}
                    idItemLicencaBaseTemp={idItemLicencaBaseTemp} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <Redirecionar
                    se={salvo}
                    para='/licencabase' />
            </RxlibLayout>
        </>
    );
}

export default LicencaBaseCadastro;